<template>
  <div class="signup-container">
  <div class="container-fluid banner-alt mt-3">
    <div class="row">
      <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
            >keyboard_arrow_left</span>
      </div>
    </div>
  </div>
  <div class="mt-5">
    <login :full-screen="true" />
  </div>

</div>


</template>

<script>
import Login from "@/components/user/login";
import {mapGetters} from "vuex";

export default {
  components: {
    Login
  },
  mounted() {
    if(!this.isBranded()){
      this.$router.back()
    }
  },
  methods: {
    ...mapGetters(["currentStoreDoc"]),
    goBack() {
      if(!this.$route.params.storename){
        this.$router.back()
        return
      }
      this.$router.push("/store/" + this.$route.params.storename);
    },
  }
};
</script>
